import identity from 'transmute/identity';
// @ts-expect-error file is untyped
import { createAction } from 'flux-actions';
import { REUPLOAD_DOCUMENT_CREATE_SUCCEEDED, REUPLOAD_DOCUMENT_CREATE_FAILED } from 'documents-lib/js/constants/ActionTypes';
import * as UploadApi from 'documents-ui/api/UploadApi';
import { addAlert } from 'documents-lib/js/utils/addAlert';
const reuploadDocumentSuccess = createAction(REUPLOAD_DOCUMENT_CREATE_SUCCEEDED, identity);
const reuploadDocumentFailed = createAction(REUPLOAD_DOCUMENT_CREATE_FAILED, identity);
export default (({
  deckId,
  fileName,
  progressionRequest,
  onPercentProgress
}) => dispatch => {
  const handleUploadProgress = percent => {
    if (onPercentProgress) {
      onPercentProgress(percent);
    }
  };
  return progressionRequest(handleUploadProgress).then(progressionData => {
    return UploadApi.uploadProgressionData(progressionData, handleUploadProgress);
  }).then(documentData => {
    addAlert('reuploadFile', 'success', {
      name: documentData.get('title')
    });
    dispatch(reuploadDocumentSuccess(documentData));
    return documentData;
  }).catch(() => {
    addAlert('reuploadFile', 'danger', {
      name: fileName
    });
    dispatch(reuploadDocumentFailed(deckId));
    return null;
  });
});